/* クエリ変換用コード */

export default {
    queryStr2Array: function(q) {
        try {
            return [...q].map(c => parseInt(c));  
        } catch (e) {
            return null;
        }
    },
    array2queryStr: function(a) {
        console.log("query.a", a);
        try {
            return a.join("");
        } catch (e) {
            return null;
        }
    }
}